import React from 'react';
import AsyncModule from '../../utils/asyncModule';
import extract from '../../utils/extractUrlParams';

const loader = async () => {
    return await import(/* webpackChunkName: "Dashboard" */ './views/main.c');
};

export default class extends React.Component {
    static displayName = 'Dashboard';

    render() {
        let {match = {}} = this.props;

        return (
            <AsyncModule
                {...this.props}
                params={extract(match.params && match.params.json)}
                loader={loader}
            />
        );
    }
}
